var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-note",class:_vm.clazz},[(_vm.icon)?_c('i',{staticClass:"icon banana",class:_vm.icon,attrs:{"aria-hidden":"true"}}):_vm._e(),_c('span',{staticClass:"note-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }